<div class="container preview-rewards">
  <ng-container *ngIf="mixedLoyaltyItems.length">
    <div class="featured-rewards-bg d-flex">
      <div class="container my-auto px-0">
        <h5 class="preview-featured-rewards-heading">
          {{ 'fgbcl.preview.rewards.title' | translate }}
        </h5>
        <div class="preview-featured-rewards-description">
          {{ 'fgbcl.preview.rewards.description' | translate }}
        </div>
        <div id="rewards-carousel">
          <owl-carousel-o [options]="customOptions()">
            <ng-container *ngFor="let item of mixedLoyaltyItems">
              <ng-template carouselSlide [width]="mixedLoyaltyItems.length <= 2 ? itemWidth : 0">
                <ng-container [ngSwitch]="item.type">
                  <fgbcl-auction-panel
                    *ngSwitchCase="'auction'"
                    [auctionItem]="item.data.AuctionItem"
                    [ignoreLink]="true"
                    [isPreview]="true"
                  ></fgbcl-auction-panel>
                  <fgbcl-marketplace-list-item
                    *ngSwitchCase="'marketplace'"
                    [marketplaceItem]="item.data"
                    [ignoreLink]="true"
                  ></fgbcl-marketplace-list-item>
                  <fgbcl-lottos-list-item
                    *ngSwitchCase="'lotto'"
                    [lottoItem]="item.data"
                    [ignoreLink]="true"
                    [isPreview]="true"
                  ></fgbcl-lottos-list-item>
                </ng-container>
              </ng-template>
            </ng-container>
          </owl-carousel-o>
        </div>
      </div>
    </div>
  </ng-container>
</div>
